import React from 'react';
import { Link } from 'react-router-dom';
import { getProductImageUrl } from '../../../services/api';

const TopPerformingPanels = ({ panels = [], loading }) => {
  return (
    <div className="top-products-card">
      <div className="card-header-flex" style={{ marginBottom: '10px' }}>
        <h3 style={{ fontSize: '12px', fontWeight: 800, color: '#dc2626', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
          TOP PERFORMING PANELS
        </h3>
        <Link to="/admin/panels" className="view-all-link" style={{ fontSize: '12px' }}>View All</Link>
      </div>

      <div className="top-products-list">
        {loading ? (
          <div style={{ padding: '20px', textAlign: 'center', color: '#64748b', fontSize: '13px' }}>Loading top panels...</div>
        ) : !panels || panels.length === 0 ? (
          <div style={{ padding: '20px', textAlign: 'center', color: '#64748b', fontSize: '13px' }}>No panel sales recorded yet.</div>
        ) : (
          panels.map((item, idx) => (
            <div key={item.id} className="product-row-item">
              <div className="product-row-left">
                <span style={{ fontSize: '12px', fontWeight: 800, color: '#dc2626', width: '16px' }}>{idx + 1}</span>
                <div className="product-img-box">
                  <img src={getProductImageUrl(item.image_url)} alt={item.name} onError={(e) => { e.target.src = getProductImageUrl('/uploads/panel_144led_pro.jpg'); }} />
                </div>
                <div className="product-info-col">
                  <span className="product-item-title">{item.name}</span>
                  <span className="product-item-sales">{item.units_sold} Units Sold</span>
                </div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <span className="product-item-price">£{Number(item.total_revenue || 0).toFixed(2)}</span>
                <span style={{ fontSize: '11px', color: '#10b981', fontWeight: 700 }}>Active Product</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default TopPerformingPanels;
